module.exports = __webpack_public_path__ + "img/DM.eaeffa06.svg";